import { queryOptions, useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

import type { RecitalStats } from '../model/recital';

export const getRecitalStatsAPI = async (recitalId: string) => {
  const response = await baseAPI.get<RecitalStats>(
    `/recitals/${recitalId}/stats`,
  );
  return response.data;
};

export const getRecitalStatsOptions = (recitalId: string) => {
  return queryOptions({
    queryKey: [KEYS.RECITALS, recitalId, KEYS.STATS],

    queryFn: () => getRecitalStatsAPI(recitalId),
    staleTime: 1000 * 60 * 5,
  });
};

export const useGetRecitalStats = (recitalId: string) => {
  return useQuery(getRecitalStatsOptions(recitalId));
};
